const stripLeadingSlash = function(s) {
    return s = (s.length && s[0] == '\\') ? s.slice(1) : s;
}

export var contentToText = function(content,components) {
    return content.filter((o) => o.type=="text"||o.type=="component").map((o) => o.type=="text"?stripLeadingSlash(o.value):components[o.value])
};


// WEBPACK FOOTER //
// ./src/js/utils/helpers.jsx